export const KEYBOARD_STATUS_EVENT = "keyboardStatus";
